import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const ReportSingle = () => {

  // Get Report details passed via router state
  const location = useLocation();
  const report = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={report.title} page={"Report Single"} />

      <section className='report-single page-single'>

        <div className='report-info page-info'>

          {/* Report Image */}
          <div className='image'>
            <img src={report.image} alt={report.title} />
          </div>

          <div className='content'>

            {/* Report Title */}
            <h3 className='main-heading'>{report.title}</h3>

            {/* Report Description */}
            {report.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Report Image Gallery */}
            <Lightbox images={report.gallery} />

            {/* Response and Actions Taken */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Response and Actions Taken:</h3>
              <p>A summary of the key responses implemented and significant actions taken as part of the {report.title}:</p>

              {/* Report Actions */}
              <ul>
                {report.actions.map((action, index) => {
                  return <li key={index}><FaCheck className='icon' />{action}</li>
                })}
              </ul>

            </div>

            {/* Lessons learned */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Lessons learned:</h3>
              <p>Valuable insights and takeaways gained from the planning and execution of {report.title}:</p>

              {/* List of Lessons */}
              <ul>
                {report.lessons.map((lesson, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{lesson}</li>
                })}
              </ul>

            </div>

            {/* Preventions and Safety Tips */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Preventions and Safety Tips:</h3>

              <p>Helpful precautions and safety measures to prevent similar issues in the future:</p>

              {/* Safety Tips */}
              <ul>
                {report.preventions.map((prevention, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{prevention}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Report details */}
        <PageSidebar
          heading={'Report'}
          details={report.details}
        />

      </section>

    </> 
  );
}

export default ReportSingle;